







































































































































































































































import * as XLSX from 'xlsx';
import {WorkSheet} from 'xlsx';
import JsonViewer from 'vue-json-viewer'
import {Component, Vue} from "vue-property-decorator";
import {Getter, Mutation} from "vuex-class";
import axios from "axios";
import ImageComponent from "@/valchrom/views/mathservice/dataset/overview/ImageComponent.vue";
import BCheckbox from "buefy/src/components/checkbox/Checkbox.vue";

const {read, write, utils} = XLSX;


@Component({
    components: {
        BCheckbox,
        JsonViewer,
        ImageComponent
    }
})
export default class ViewInput extends Vue {
    @Getter base_url !: any;
    @Getter auth_header !: any;
    @Getter token !: any;
    @Getter math_service_url !: any;
    @Getter currentExperimentalDatasetID !: any;
    @Getter validationParameters !: any;
    @Mutation SET_BREADCRUMB!: (_: any) => any;
    @Mutation CHANGE_EXPERIMENTAL_DATASET_ID!: (_: any) => any;

    constantPasteText = "You can paste your table here.";

    isValidated: boolean = false;
    columns: string[] = [];
    rows: { [key: string]: any; }[] = [];
    amName: string = "";
    /* TODO ASKO look into if you can pass a clean single object here*/
    amDisplay: string = "";
    validationParameterDisplay: string = "";
    validation: any = {
        valid: true,
        message: ""
    };
    chromatograms:any = null;
    images:any = "";
    uploadingImage: boolean = false;
    forceToZero: boolean = false;
    templateSheet : any= null;
    alfaValue: number = 5;
    kValue: number = 1;

    mounted() {
        this.setBreadcrumb();
        let datasetId = this.$route.params.dataset_id;
        let amName = this.$route.params.am_name;
        this.amName = amName;
        this.amDisplay = this.$route.params.am_display;
        this.validationParameterDisplay = this.$route.params.validation_parameter_display;
        this.setExperimentalDatasetId(datasetId);
        this.getInput(datasetId, amName);
        //var wb = XLSX.read(data);

    }

    getLineNr(rowIn : any){
        var lineNr = 0;
        for(let rowInData of this.rows){
            lineNr++;
            if(rowIn == rowInData){
                return lineNr;
            }
        }
        return -1;
    }

    private getInput(datasetId: string, amName: string) {
        let inputUrl = this.math_service_url + "dataset/" +
            datasetId + "/input";
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        let self = this;
        axios.get(
            inputUrl,
            {
                headers: {
                    jwt: this.token
                },
                params: {
                    am: amName
                },
                withCredentials: true
            }
        )
            .then(
                response => {
                    console.log("Got response input", response);
                    this.forceToZero = response.data.forzeToZero;
                    if(this.isCsvAM(amName)){
                        let csv = response.data.csv;
                        if (csv == null) {
                            self.getTemplate(amName);
                        } else {
                            let csvID = csv.id;
                            console.log("CSV id", csvID);
                            self.getCSV(datasetId, csvID);
                        }
                        let ccaccbData = response.data.ccaccbData;
                        if(ccaccbData){
                            this.alfaValue = ccaccbData.alfa * 100;
                            this.kValue = ccaccbData.k;
                        }
                        self.retrieveTemplate(amName);
                    } else {
                        this.chromatograms = response.data.chromatograms;
                        if(!this.chromatograms){
                            this.chromatograms = {};
                            this.chromatograms.chromatogramsByAnalyte = {}
                        }
                        for(let analyte of response.data.datasetInfo.method.analytes){
                            let chromatogramsByAnalyte = this.chromatograms.chromatogramsByAnalyte;
                            let abbreviation = analyte.abbreviation;
                            if(!chromatogramsByAnalyte[abbreviation]){
                                chromatogramsByAnalyte[abbreviation] = [];
                            }
                        }
                    }
                })
            .catch(
                error => {
                    console.log("error on GET input", error);
                }
            );
    }

    isCsvAM(amName: string) {
        return !amName.startsWith("UPLOAD");
    }

    hasSN() {
        return this.amName.startsWith("UPLOAD_S_N");
    }

    isCCA(){
        return this.amName.startsWith("CCA_CCB");
    }

    hasLoD() {
        return !this.amName.startsWith("UPLOAD_PIC");
    }

    toggleLoD(image : any){
        if(image.isLoD){
            image.isLoQ = false;
            for(let image2 of this.images){
                console.log(image2, image != image2);
                if(image != image2){
                    image2.isLoD = false;
                }
            }
        }
    }

    toggleLoQ(image : any){
        if(image.isLoQ){
            image.isLoD = false;
            for(let image2 of this.images){
                console.log(image2, image != image2);
                if(image != image2){
                    image2.isLoQ = false;
                }
            }
        }
    }

    saveForceToZero(){
        let request = {
            amName : this.amName,
            type : "FORCE_TO_ZERO",
            content:JSON.stringify(this.forceToZero)
        };

        let url = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/input-part";
        let self = this;
        axios.put(url, request, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                console.log("FTZ - Input part set",result.data);
                //self.getValidation();
            }, function (error) {
                console.log("FTZ - Setting input part failed.",error.data);
            });
    }

    getCSV(datasetId: string, csvID: any) {
        ///dataset/1/file/id?dataset_id=!
        let csvUrl = this.math_service_url + "dataset/" +
            datasetId + "/file/" + csvID;
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.get(
            csvUrl,
            {
                headers: {
                    jwt: this.token
                },
                withCredentials: true
            }
        )
            .then(
                response => {
                    console.log("Got csv file response", response);
                    let wb = XLSX.read(response.data, {
                        type: 'buffer',
                        raw: true
                    });
                    let sheet = wb.Sheets[wb.SheetNames[0]];
                    this.displaySheet(sheet);
                })
            .catch(
                error => {
                    console.log("error on GET csv file", error);
                }
            );
    }

    /* TODO ASKO templates seem to come from math module*/
    getTemplate(amName: string) {
        ///dataset/1/file/id?dataset_id=!
        let templateUrl = this.math_service_url + "assessmentmethods/" +
            amName + "/example";
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.get(
            templateUrl,
            {}
        )
            .then(
                response => {
                    console.log("template response.data", response.data);
                    let wb = XLSX.read(response.data, {
                        type: 'binary',
                    });
                    let sheet = wb.Sheets[wb.SheetNames[0]];
                    this.displayTemplate(sheet);
                })
            .catch(
                error => {
                    console.log("error on GET template", error);
                }
            );
    }

    retrieveTemplate(amName: string) {
        ///dataset/1/file/id?dataset_id=!
        let templateUrl = this.math_service_url + "assessmentmethods/" +
            amName + "/example";
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.get(
            templateUrl,
            {}
        )
            .then(
                response => {
                    console.log("template response.data", response.data);
                    let wb = XLSX.read(response.data, {
                        type: 'binary',
                    });
                    this.templateSheet = wb.Sheets[wb.SheetNames[0]];
                })
            .catch(
                error => {
                    console.log("error on GET template", error);
                }
            );
    }

    setExperimentalDatasetId(datasetId: any) {
        this.CHANGE_EXPERIMENTAL_DATASET_ID(datasetId)
    }

    setBreadcrumb() {
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    }

    handlePaste(event: ClipboardEvent) {
        let clipboardData: DataTransfer = event.clipboardData as DataTransfer;
        let paste = clipboardData.getData('text');
        let wb = XLSX.read(paste, {
            type: 'string',
            raw: true
        });
        let sheet = wb.Sheets[wb.SheetNames[0]];
        this.displaySheet(sheet);
        this.constantPasteText = "You can paste your table here.";
        event.preventDefault();
    }

    back(){
        this.$router.push({ name: "ViewDataset", params: {id:this.currentExperimentalDatasetID} });
    }

    showResults(){
        this.$router.replace({ name: "NewOverview", params: {dataset_id: this.currentExperimentalDatasetID} });
    }


    private displaySheet(sheet: WorkSheet) {
        let json: any = XLSX.utils.sheet_to_json(sheet);
        console.log("json", json);

        this.columns = [];
        for (let row of json) {
            for (let field in row) {
                if (this.columns.indexOf(field) == -1) {
                    this.columns.push(field);
                }
            }
        }
        this.rows = [];
        for (let row of json) {
            let obj: { [k: string]: any } = {};
            for (let column of this.columns) {
                let col = column as string;
                obj[col] = row[col] || "";
            }
            this.rows.push(obj);
        }
        console.log("compiled rows", this.rows)
    }

    private displayTemplate(sheet: WorkSheet) {
        let json: any = XLSX.utils.sheet_to_json(sheet, {header: 1, raw: true});
        console.log("template json", json);
        this.columns = json[0];
        let row : any = {};
        for(let column of this.columns){
            row[column] = "";
        }
        this.rows = [row];
    }

    handleFileSelect(event: any) {
        let file = event.target.files[0];
        event.target.value = "";
        var reader = new FileReader();
        reader.onload = () => {
            var data = new Uint8Array(reader.result as ArrayBuffer);
            var workbook = XLSX.read(data, {type: 'array', raw:true});
            var worksheet = workbook.Sheets[workbook.SheetNames[0]];
            console.log("Loaded worksheet from disk", worksheet);
            this.displaySheet(worksheet);
        };
        reader.readAsArrayBuffer(file);
    }

    addImageToAnalyte(event: any) {
        let file = event.target.files[0];
        event.target.value = "";

        const formData = new FormData();
        formData.append("file", file, "data.csv");
        let fileUploadUrl = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/file";
        let self = this;
        this.uploadingImage = true;
        axios.post(fileUploadUrl, formData, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                console.log("Image uploaded.",result.data);
                self.uploadingImage = false;
                let fileID = result.data;
                self.images.push({
                    image : fileID
                });
            }, function (error) {
                console.log("Image upload failed.",error.data);
                self.uploadingImage = false;
            });
    }

    upload(){
        var ws = this.getWorkSheet();
        var csv = XLSX.utils.sheet_to_csv(ws,{rawNumbers:true, forceQuotes: true});
        console.log("made worksheet into CSV", csv);
        var blob = new Blob([csv], {type: 'text/plain'});
        let file = this.blobToFile(blob, "data.csv");
        const formData = new FormData();
        formData.append("file", file, "data.csv");
        let fileUploadUrl = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/file";
        let self = this;
        if(this.isCCA()){
            self.setAlfaBetaInputPart();
        }
        axios.post(fileUploadUrl, formData, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                let fileID = result.data;
                console.log("File uploaded",fileID);
                self.setCsvInputPart(fileID);
            }, function (error) {
                console.log("File upload failed.",error.data);
            });
    }

    setAlfaBetaInputPart(){
        let request = {
            amName : this.amName,
            type : "ALFA_BETA",
            content:JSON.stringify({alfa:this.alfaValue/100,k:this.kValue})
        };

        let url = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/input-part";
        let self = this;
        axios.put(url, request, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                console.log("Input part set",result.data);
                self.getValidation();
            }, function (error) {
                console.log("Setting input part failed.",error.data);
            });
    }

    setCsvInputPart(fileID: any) {
        let request = {
            amName : this.amName,
            type : "CSV_FILE",
            content:JSON.stringify(fileID)
        };

        let url = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/input-part";
        let self = this;
        axios.put(url, request, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                console.log("Input part set",result.data);
                self.getValidation();
            }, function (error) {
                console.log("Setting input part failed.",error.data);
            });
    }

    uploadImages() {
        let request = {
            amName : this.amName,
            type : "CHROMATOGRAMS",
            content:JSON.stringify(this.chromatograms)
        };

        let url = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/input-part";
        let self = this;
        axios.put(url, request, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                console.log("Input part set",result.data);
                self.getValidation();
            }, function (error) {
                console.log("Setting input part failed.",error.data);
            });
    }

    getValidation() {
        let url = this.math_service_url+"dataset/"+
            this.currentExperimentalDatasetID+"/validation";
        let self = this;
        axios.get(url, {
            headers: {
                jwt: this.token
            },
            withCredentials: true,
            params : {
                am : this.amName
            }
        })
        .then(function (result) {
            console.log("Validation received",result.data);
            self.validation = result.data;
            if(self.validation.valid){
                self.isValidated = true;
                self.$toast.open({
                    duration: 5000,
                    message: `Data uploaded`,
                    position: 'is-top',
                    type: 'is-primary'
                })
            } else {
                self.$toast.open({
                    duration: 5000,
                    message: `Input is invalid!`,
                    position: 'is-top',
                    type: 'is-danger'
                })
            }
        }, function (error) {
            console.log("Getting validation failed.",error.data);
        });
    }

    blobToFile(theBlob: Blob, fileName:string): File{
        var b: any = theBlob;
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        b.lastModifiedDate = new Date();
        b.name = fileName;

        //Cast to a File() type
        return <File>theBlob;
    }

    downloadData(){
        var ws = this.getWorkSheet();

        this.downloadSheet(ws);
    }

    downloadTemplate(){
        this.downloadSheet(this.templateSheet);
    }

    /* TODO ASKO location of template download*/
    private downloadSheet(ws:WorkSheet) {
        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "data");

        /* generate an XLSX file */
        XLSX.writeFile(wb, "data.xlsx");
    }

    private getWorkSheet() {
        let rows = this.rows;
        let headerRow :any = {};
        for (let column of this.columns) {
            headerRow[column] = column;
        }
        let headerRows = [headerRow];
        rows = headerRows.concat(rows);
        for (let row of rows) {
            for (let column of this.columns) {
                row[column] = row[column] || "";
            }
        }
        for (let i = 0; i < this.columns.length; i++) {
            for (let row of rows) {
                delete row[i]
            }
        }
        /* make the worksheet */
        return XLSX.utils.json_to_sheet(rows, {skipHeader: true});
    }
}
